var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pet-list-item"},[_c('img',{staticClass:"pet-image",attrs:{"src":_vm.getImageUrl(_vm.PetDetails),"alt":_vm.PetDetails.Name}}),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.PetDetails.Name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-373d38cd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PetListItem.vue
// module id = null
// module chunks = 